<template>
<div style="background: transparent linear-gradient(241deg, rgb(210 229 241 / 33%) 0%, rgb(31 127 185 / 33%) 100%) 0% 0% padding-box; min-height: 55vw;">
    <div class="container py-5 py-sm-6 py-md-7" style="min-height: 100vh;">
        <div class="row justify-content-center">
            <div class="col-lg-9 col-md-9 col-sm-11" style="background-color: var(--bs-body-bg); border-radius: 1rem; box-shadow: 6px 3px 3px #00000029;">
                <div v-if="showMeetingInfo && !busy" class="py-3 pb-2" style="margin: 10px;">
                    <div class="mt-3 mb-n2" style="text-align: center;">
                        <img class="d-none d-md-none d-lg-inline-block" src="~resonance-theme/src/assets/img/brand/resonance-logo-text.svg" style="max-width: 320px; margin-bottom: 50px;"/>
                        <img class="d-lg-none d-xl-none" src="~resonance-theme/src/assets/img/brand/resonance-logo-text.svg" style="max-width: 65%; margin-bottom: 40px;"/>
                    </div>
                    <div class="row mb-3">
                        <!--Desktop-->
                        <div class="card">
                            <div class="wrapper d-none d-md-none d-lg-block" style="position: relative;">
                                <div class="image">
                                    <img v-if="network.cover_url" :src="network.cover_url" class="card-image" />
                                    <img v-else src="@/assets/img/networks-home-default-banner.jpeg" class="card-image" />
                                    <span>{{ network.slug }}</span>
                                </div>
                                <div class="data">
                                    <div class="content">
                                        <h4 class="title">{{ meeting.title.slice(0, 95) }}<span v-if="meeting.title.length > 95" class="fs-4">...</span></h4>
                                        <h6 :style="{ bottom: meeting.presenter ? '40px' : '20px' }">
                                            <b>{{ network.short_name }}</b> {{ frequency() }} {{ $t('network.meeting') }}
                                        </h6><br />
                                        <span v-if="meeting.presenter" style="bottom: 30px; font-weight: 500;">
                                            <div v-for="(value, index) in meeting.presenter" :key="value.name" class="ignore-css">
                                                {{ value.name }}
                                                <b v-if="index != meeting.presenter.length - 1">&bullet;</b>
                                            </div>
                                        </span>
                                        <span style="right: 10px; bottom: 6px;">{{ utcToLocal(meeting.start).format('MMM DD, YYYY - hh:mm A') }}</span>
                                        <div v-if="timeToMeeting(meeting.start).futureMeeting || timeToMeeting(meeting.start).meetingAboutToStart">
                                            <span style="bottom: 6px;">
                                                <i class="fas fa-clock text-primary" style="font-size: 16px;"></i>
                                                {{ $t('meeting.starting-in') }}
                                                <div v-if="timeToMeeting(meeting.start).months > 0" class="ignore-css">
                                                    {{ timeToMeeting(meeting.start).months }} {{ $t('months') }},
                                                </div>
                                                <div v-if="timeToMeeting(meeting.start).days > 0" class="ignore-css">
                                                    {{ timeToMeeting(meeting.start).days }} {{ $t('days') }},
                                                </div>
                                                <div v-if="timeToMeeting(meeting.start).hours > 0" class="ignore-css">
                                                    {{ timeToMeeting(meeting.start).hours }} {{ $t('hours') }}, {{ $t('CardFull.and') }}
                                                </div>
                                                {{ timeToMeeting(meeting.start).minutes }} {{ $t('NetworkMeetingForm.minutes').toLowerCase() }}.
                                            </span>
                                        </div>
                                        <div v-if="timeToMeeting(meeting.start).liveMeeting">
                                            <span style="bottom: 6px;">
                                            <i class="fas fa-clock text-primary" style="font-size: 16px;"></i>
                                                {{ $t('meeting.happening-now') }}
                                            </span>
                                        </div>
                                        <div v-if="timeToMeeting(meeting.start).oldMeeting">
                                            <span style="bottom: 6px;">
                                            <i class="fas fa-exclamation-circle text-danger" style="font-size: 18px;"></i>
                                                {{ $t('meeting.this-is-an-old-meeting') }} </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!--Mobile & tablet-->
                            <div class="wrapper d-lg-none d-xl-none" style="position: relative;">
                                <div class="data" style="all: unset !important;">
                                    <div style="padding: 10px 8px; color: #5C6D80;">
                                        <h4>{{ meeting.title }}</h4>
                                        <h6 :style="{ bottom: meeting.presenter ? '40px' : '20px' }" style="font-size: 14px;">
                                            <b>{{ network.short_name }}</b> {{ frequency() }} {{ $t('network.meeting') }}
                                        </h6>
                                        <span v-if="meeting.presenter" style="font-weight: 500; font-size: 14px;">
                                            <div v-for="(value, index) in meeting.presenter" :key="value.name" class="ignore-css">
                                                {{ value.name }}
                                                <b v-if="index != meeting.presenter.length - 1">&bullet;</b>
                                            </div>
                                        </span>
                                        <div v-if="timeToMeeting(meeting.start).futureMeeting || timeToMeeting(meeting.start).meetingAboutToStart"
                                        style="padding-top: inherit; display: flex; justify-content: space-between;">
                                            <span style="font-weight: 700; font-size: 14px;">
                                                <i class="fas fa-clock text-primary" style="font-size: 16px;"></i>
                                                {{ $t('meeting.starting-in') }}
                                                <div v-if="timeToMeeting(meeting.start).months > 0" class="ignore-css">
                                                    {{ timeToMeeting(meeting.start).months }} {{ $t('months') }},
                                                </div>
                                                <div v-if="timeToMeeting(meeting.start).days > 0" class="ignore-css">
                                                    {{ timeToMeeting(meeting.start).days }} {{ $t('days') }},
                                                </div>
                                                <div v-if="timeToMeeting(meeting.start).hours > 0" class="ignore-css">
                                                    {{ timeToMeeting(meeting.start).hours }} {{ $t('hours') }}, {{ $t('CardFull.and') }}
                                                </div>
                                                {{ timeToMeeting(meeting.start).minutes }} {{ $t('NetworkMeetingForm.minutes').toLowerCase() }}.
                                            </span>
                                            <span style="font-size: 14px; text-align: end; font-weight: 700;">
                                                {{ utcToLocal(meeting.start).format('MMM DD, YYYY hh:mm A') }}
                                            </span>
                                        </div>
                                        <div v-if="timeToMeeting(meeting.start).liveMeeting" style="padding-top: inherit;">
                                            <span style="font-weight: 700; font-size: 14px;">
                                                <i class="fas fa-clock text-primary" style="font-size: 16px;"></i>
                                                {{ $t('meeting.happening-now') }}
                                            </span>
                                        </div>
                                        <div v-if="timeToMeeting(meeting.start).oldMeeting" style="padding-top: inherit;">
                                            <span style="font-weight: 700; font-size: 14px;">
                                                <i class="fas fa-exclamation-circle text-danger" style="font-size: 18px;"></i>
                                                {{ $t('meeting.this-is-an-old-meeting') }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <form v-if="showUserForm && !timeToMeeting(meeting.start).oldMeeting" @submit.prevent="submitForm">
                        <div class="row py-1">
                            <div class="col-md-12">
                                <label v-if="timeToMeeting(meeting.start).futureMeeting" for="email" class="form-label p-0 mb-3">
                                    To access the sharing links, please enter your email address.
                                </label>
                                <label v-else for="email" class="form-label p-0 mb-3">
                                    {{ $t('meeting.to-access-the-zoom-meeting-please-enter-your-email-address') }}
                                </label>
                                <input id="email" v-model="form.email" data-test="email" class="form-control" type="email" placeholder="your.email@gmail.com" required autofocus>
                            </div>
                        </div>
                        <div class="text-center">
                            <button id="submit" data-test="submit" class="btn btn-primary btn mt-4" type="submit">{{ $t('submit') }}</button>
                            <div class="separator my-3 text-secondary">{{ $t('network.member.or') }}</div>
                            <span data-umami-event="sign-in" class="text-center text-primary fw-bold" style="cursor: pointer;" @click="$bus.emit('go-to-sign-in', $route.fullPath)">
                                {{ $t('sign-in-with-resonance') }}
                            </span>
                        </div>
                    </form>
                    <form v-if="showNewUserForm && !timeToMeeting(meeting.start).oldMeeting" @submit.prevent="validateInputs('create')">
                        <div class="my-3 ms-2">
                            {{ $t('meeting.please-enter-your-details-below-to-access-our-meeting-resonance-asks-for-single-time-registration-in-order-to-ensure-meetings-foster-networking-between-health-care-professionals') }}
                        </div>
                        <div class="row py-1">
                            <div class="col-md-12">
                                <label class="form-label p-0">Select one option:<sup class="text-danger ms-1">*</sup></label><br>
                                <label class="col-md-5">
                                    <input v-model="selectedRole" type="radio" name="role" value="hcp">&nbsp;
                                    Healthcare practitioner
                                </label>
                                <label class="col-md-3">
                                    <input v-model="selectedRole" type="radio" name="role" value="industry">&nbsp;
                                    Industry
                                </label>
                                <label class="col-md-4">
                                    <input v-model="selectedRole" type="radio" name="role" value="other">&nbsp;
                                    Other
                                </label>
                            </div>
                        </div>
                        <div class="row py-1">
                            <div v-if="timeToMeeting(meeting.start).futureMeeting" class="col-md-2">
                                <label for="name_prefix" class="form-label p-0">{{ $t('network.networkForm.prefix') }}</label>
                                <input id="name_prefix" v-model="form.name_prefix" data-test="name_prefix" type="text" placeholder="Mr./Mrs./Ms./Dr." class="form-control">
                            </div>
                            <div :class="timeToMeeting(meeting.start).futureMeeting ? 'col-md-4' : 'col-md-6'">
                                <label for="first_name" class="form-label p-0">{{ $t('network.auth.firstName') }}<sup class="text-danger ms-1">*</sup></label>
                                <input id="first_name" v-model="form.first_name" data-test="first_name" type="text" placeholder="John" class="form-control">
                            </div>
                            <div :class="timeToMeeting(meeting.start).futureMeeting ? 'col-md-4' : 'col-md-6'">
                                <label for="last_name" class="form-label p-0">{{ $t('network.auth.lastName') }}<sup class="text-danger ms-1">*</sup></label>
                                <input id="last_name" v-model="form.last_name" data-test="last_name" type="text" placeholder="Doe" class="form-control">
                            </div>
                            <div v-if="timeToMeeting(meeting.start).futureMeeting" class="col-md-2">
                                <label for="name_suffix" class="form-label p-0">{{ $t('network.auth.nameSuffix') }}</label>
                                <input id="name_suffix" v-model="form.name_suffix" data-test="name_suffix" type="text" placeholder="MD/PhD/Jr/Sr." class="form-control">
                            </div>
                        </div>
                        <div class="row py-1">
                            <div class="col-md-12">
                                <label for="job_title" class="form-label p-0">{{ $t('network.auth.workplace.job_title') }}<sup class="text-danger ms-1">*</sup></label>
                                <input id="job_title" v-model="form.job_title" data-test="job_title" type="text" placeholder="Oncologist / Resident" class="form-control">
                            </div>
                        </div>
                        <div class="row py-1">
                            <div class="col-md-12">
                                <label for="workplace" class="form-label p-0">{{ $t('network.auth.work-place') }}<sup class="text-danger ms-1">*</sup></label>
                                <input id="workplace" v-model="form.workplace" data-test="workplace" type="text" placeholder="General Hospital Inc." class="form-control">
                            </div>
                        </div>
                        <div class="row py-1">
                            <div class="col-md-6">
                                <label for="country_workplace" class="form-label p-0">{{ $t('network.auth.workplace_country') }}<sup class="text-danger ms-1">*</sup></label>
                                <v-select
                                    id="country_workplace"
                                    v-model="form.country_workplace"
                                    data-test="country_workplace"
                                    :options="countries"
                                    label="name"
                                    placeholder="Select a country or region"
                                >
                                </v-select>
                            </div>
                            <div class="col-md-6">
                                <label for="city_workplace" class="form-label p-0">{{ $t('network.auth.workplace_city') }}<sup class="text-danger ms-1">*</sup></label>
                                <input v-if="form.country_workplace.name != 'UNITED STATES'" id="city_workplace" v-model="form.city_workplace" data-test="city_workplace" type="text" placeholder="Memphis" class="form-control">
                                <v-select
                                    v-else
                                    id="city"
                                    v-model="state"
                                    data-test="city"
                                    :options="states"
                                    label="name"
                                    placeholder="Select a state"
                                >
                                </v-select>
                            </div>
                        </div>
                        <div v-if="timeToMeeting(meeting.start).futureMeeting">
                            <div class="row py-1">
                                <div class="col-md-6">
                                    <label for="speciality" class="form-label p-0">{{ $t('network.auth.workplace_job_category_other') }}</label>
                                    <input id="speciality" v-model="form.speciality" data-test="speciality" type="text" placeholder="Pediatric Oncology" class="form-control">
                                </div>
                                <div class="col-md-6">
                                    <label for="phone_number" class="form-label p-0">{{ $t('network.auth.phone') }}</label>
                                    <input id="phone_number" v-model="form.phone_number" data-test="phone_number" type="text" placeholder="+1 555-111-1234" class="form-control">
                                </div>
                            </div>
                        </div>
                        <div class="form-group form-check mt-2 ms-3">
                            <input id="join-checkbox" v-model="form.join_network" data-test="join-checkbox" type="checkbox" class="form-check-input" style="font-size: large;" />
                            <label class="form-check-label" style="vertical-align: bottom;">{{ $t('join-the-network-after-registration') }}</label>
                        </div>
                        <div class="text-center">
                            <button id="submit" data-test="submit" type="submit" class="btn btn-primary btn mt-4">{{ $t('submit') }}</button>
                        </div>
                    </form>
                    <div v-if="showShareLinks && timeToMeeting(meeting.start).futureMeeting">
                        <div>
                            <div class="mt-4">
                                <span>
                                    {{ $t('thanks-for-your-interest-please-come-back-on-it-will-open-20-minutes-before-the-start-time-in-the-meantime-you-can-save-the-meeting-to-your-calendar', { time: utcToLocal(meeting.start).format('MMMM DD, YYYY') }) }}
                                </span>
                            </div>
                            <hr />
                            <div class="text-center mt-3 fw-semibold icons">
                                <!--Desktop-->
                                <div class="d-none d-md-none d-lg-block">
                                    <a :data-umami-event="occurrence? 'add-to-calendar-occurrence-google' : 'add-to-calendar-meeting-google'" :data-umami-event-id="occurrence ?? meeting.id"
                                    style="border-right: 1px solid #5C6D80; cursor: pointer;" @click="addToCalendar('Google', meeting.calendar_links.google)">
                                        <svg width="45" height="40" viewBox="0 0 122 109" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M85.737 30.2629L63.474 27.7893L36.2634 30.2629L33.7893 55L36.2629 79.737L61 82.8291L85.737 79.737L88.2106 54.3819L85.737 30.2629Z" fill="white"/>
                                            <path d="M46.4119 68.6422C44.5629 67.3929 43.2826 65.5688 42.5837 63.1568L46.8758 61.3882C47.2654 62.8725 47.9455 64.0225 48.9165 64.8389C49.8814 65.6553
                                            51.0564 66.0572 52.4293 66.0572C53.8332 66.0572 55.0392 65.6304 56.0469 64.7769C57.0546 63.9234 57.5622 62.8349 57.5622 61.5179C57.5622 60.17 57.0301
                                            59.0687 55.9665 58.2157C54.9029 57.3626 53.5672 56.9354 51.9715 56.9354H49.4918V52.6871H51.7177C53.0906 52.6871 54.2473 52.3163 55.1873 51.5741C56.1273
                                            50.832 56.5973 49.8177 56.5973 48.5252C56.5973 47.3751 56.1766 46.4596 55.3358 45.7734C54.4949 45.0872 53.4309 44.7408 52.1384 44.7408C50.8769 44.7408
                                            49.8748 45.075 49.1327 45.7489C48.3906 46.4229 47.8524 47.2515 47.5126 48.2287L43.2643 46.4601C43.8269 44.8644 44.86 43.4544 46.3748 42.2362C47.89 41.0179
                                            49.8255 40.4055 52.1755 40.4055C53.9131 40.4055 55.4777 40.7397 56.8633 41.4137C58.2484 42.0876 59.3369 43.0215 60.1223 44.2088C60.9076 45.4021 61.2973
                                            46.7383 61.2973 48.2221C61.2973 49.7374 60.9325 51.0172 60.2026 52.0686C59.4727 53.12 58.576 53.9237 57.5124 54.4867V54.74C58.9162 55.3275 60.0602 56.2243
                                            60.9631 57.4303C61.8598 58.6363 62.311 60.0774 62.311 61.7595C62.311 63.4416 61.8843 64.9442 61.0308 66.2616C60.1773 67.579 58.9961 68.6177 57.4997
                                            69.3721C55.9971 70.1264 54.3088 70.51 52.4349 70.51C50.2645 70.5161 48.2609 69.8914 46.4119 68.6422Z" fill="#005F9A"/>
                                            <path d="M72.7497 47.3442L68.0619 50.7517L65.7058 47.1774L74.1597 41.0796H77.4004V69.8422H72.7497V47.3442Z" fill="#005F9A"/>
                                            <path d="M85.737 102L108 79.737L96.8685 74.7898L85.737 79.737L80.7898 90.8685L85.737 102Z" fill="#005F9A"/>
                                            <path d="M31.3157 90.8685L36.2629 102H85.7365V79.7371H36.2629L31.3157 90.8685Z" fill="#005F9A"/>
                                            <path d="M21.4208 8C17.321 8 14 11.321 14 15.4208V79.7366L25.1315 84.6838L36.263 79.7366V30.263H85.7366L90.6838 19.1315L85.737 8H21.4208Z" fill="#005F9A"/>
                                            <path d="M14 79.7371V94.5792C14 98.6795 17.321 102 21.4208 102H36.263V79.7371H14Z" fill="#005F9A"/>
                                            <path d="M85.7371 30.2629V79.7365H108V30.2629L96.8685 25.3157L85.7371 30.2629Z" fill="#005F9A"/>
                                            <path d="M108 30.263V15.4208C108 11.3205 104.679 8 100.579 8H85.7371V30.263H108Z" fill="#005F9A"/>
                                        </svg>
                                        <span class="me-2">{{ $t('google-calendar') }}</span>
                                    </a>
                                    <a :data-umami-event="occurrence? 'add-to-calendar-occurrence-yahoo' : 'add-to-calendar-meeting-yahoo'" :data-umami-event-id="occurrence ?? meeting.id"
                                    style="border-right: 1px solid #5C6D80; cursor: pointer;" @click="addToCalendar('Yahoo', meeting.calendar_links.yahoo)">
                                        <svg width="45" height="40" viewBox="0 0 122 109" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M56.4463 9.16263C52.8525 9.48287 48.1912 10.5148 44.9176 11.7246C42.2489 12.7031 37.7122 15.0159 35.4171 16.546C28.6031 21.1005 23.3191 27.114 19.7608
                                            34.3194C16.8964 40.1371 15.5621 45.0831 15.0995 51.6303C14.6725 57.5903 15.6333 64.4577 17.7148 70.0975C18.6934 72.7484 21.0062 77.303 22.5363 79.598C27.073
                                            86.3943 33.1042 91.7139 40.3097 95.2543C46.1274 98.1187 51.0734 99.453 57.6027 99.9156C63.5806 100.343 70.448 99.3819 76.0878 97.3003C78.7565 96.3218 83.2933
                                            94.0089 85.5883 92.4789C92.4024 87.9243 97.6863 81.9109 101.245 74.7055C104.109 68.8877 105.443 63.9418 105.906 57.4124C106.333 51.4346 105.372 44.5671 103.291
                                            38.9273C102.312 36.2764 99.9992 31.7219 98.4692 29.4268C94.8931 24.0717 90.0539 19.357 84.5209 15.8343C82.7773 14.7135 78.3117 12.543 76.0878 11.7246C70.1455
                                            9.53624 62.9045 8.59331 56.4463 9.16263ZM54.9874 38.8562V40.2795L51.9629 40.315L48.9206 40.3684L52.4611 45.6168C57.3003 52.7867 58.6168 54.6903 58.7592
                                            54.6903C58.8303 54.6903 61.0009 52.7511 63.5628 50.3671L68.2063 46.0616L65.4665 45.9726L62.7266 45.8837L62.3352 44.7273C62.1217 44.0868 61.9438 43.4285 61.9438
                                            43.2506C61.926 42.9659 62.5487 42.9481 72.4406 42.9481C79.2013 42.9481 82.9196 43.0015 82.8841 43.1261C82.8663 43.215 82.3147 43.8911 81.692 44.6383L80.5534
                                            45.9726H78.2939C76.1946 45.9726 75.9633 46.0082 75.1627 46.4352C73.2412 47.4493 66.3382 52.9646 63.3849 55.829C60.2003 58.9424 60.4315 58.2842 60.5739 63.8172C60.645
                                            66.3614 60.734 68.5141 60.7874 68.6031C60.8407 68.6742 62.7088 68.7454 64.9505 68.7454C67.4769 68.7454 69.0603 68.8166 69.1314 68.9233C69.1848 69.0301 69.1848 69.6705
                                            69.1137 70.3466L68.9891 71.592H57.5494H46.0918V70.1865V68.781L49.9169 68.7098C54.8273 68.6387 54.5071 68.8699 54.6138 65.2583C54.6494 63.835 54.6138 61.7535 54.5427
                                            60.6326C54.4181 58.6578 54.4003 58.551 53.742 57.5725C51.8918 54.8327 43.8857 45.2076 40.8612 42.0942L39.0821
                                            40.2795H35.5594H32.0368V38.8562V37.4329H43.5121H54.9874V38.8562ZM82.6172 49.2818C84.5386 49.4597 86.1221 49.6376 86.1221 49.691C86.1043 49.7444 85.1613 53.2315
                                            84.0049 57.448L81.9055 65.0982L80.251 65.0626C79.3436 65.0448 78.4896 64.9915 78.3651 64.9381C78.1516 64.8669 78.116 63.408 78.116 56.8075V48.7659L78.6142
                                            48.8726C78.881 48.926 80.6957 49.1217 82.6172 49.2818ZM80.0019 67.6957C81.0694 67.8025 81.9589 67.9092 81.9945 67.9448C82.0123 67.9626 81.9055 68.7988 81.7454
                                            69.7951L81.443 71.6098L79.735 71.503C78.7921 71.4319 77.9203 71.3607 77.8136 71.3251C77.4755 71.2184 77.4933 67.5 77.8136 67.5C77.9559 67.5 78.9344 67.589 80.0019
                                            67.6957Z" fill="#005F9A"/>
                                        </svg>
                                        <span class="me-2">{{ $t('yahoo-calendar') }}</span>
                                    </a>
                                    <a :data-umami-event="occurrence? 'add-to-calendar-occurrence-outlook' : 'add-to-calendar-meeting-outlook'" :data-umami-event-id="occurrence ?? meeting.id"
                                    style="border-right: 1px solid #5C6D80; cursor: pointer;" @click="addToCalendar('Outlook', meeting.calendar_links.outlook)">
                                        <svg width="45" height="40" viewBox="0 0 122 109" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M72.3179 28.845V46.6873L78.9089 50.6135C79.0828 50.6614 79.4594 50.6649 79.6332 50.6135L108 32.521C108 30.3798 105.889 28.845 104.697 28.845H72.3179Z"
                                            fill="#005F9A"/>
                                            <path d="M72.3215 53.0105L78.3355 57.104C79.1828 57.721 80.2038 57.104 80.2038 57.104C79.1864 57.721 108 38.7568 108 38.7568V73.0976C108 76.8359 105.585 78.4037
                                            102.87 78.4037H72.3179V53.0105H72.3215Z" fill="#005F9A"/>
                                            <path d="M42.9502 44.6423C40.955 44.6423 39.3653 45.58 38.1914 47.4517C37.0176 49.3235 36.429 51.8016 36.429 54.8859C36.429 58.0161 37.0176 60.4906 38.1914
                                            62.3095C39.3653 64.1319 40.9057 65.0378 42.8092 65.0378C44.7726 65.0378 46.3306 64.1531 47.4798 62.3835C48.6289 60.614 49.207 58.1571 49.207 55.0163C49.207 51.7416
                                            48.65 49.1931 47.5326 47.3707C46.4152 45.5518 44.8889 44.6423 42.9502 44.6423Z" fill="#005F9A"/>
                                            <path d="M15.1733 18.5749V90.3963L69.8105 101.852V8L15.1733 18.5749V18.5749ZM51.7344 66.6274C49.4255 69.6659 46.4152 71.1887 42.6999 71.1887C39.0797 71.1887
                                            36.1328 69.7153 33.8522 66.7719C31.5751 63.825 30.433 59.9899 30.433 55.2594C30.433 50.2645 31.5892 46.2248 33.9051 43.1405C36.221 40.0561 39.2877 38.5122 43.1053
                                            38.5122C46.7113 38.5122 49.63 39.9856 51.8542 42.9396C54.082 45.8935 55.1959 49.7851 55.1959 54.6178C55.1994 59.5845 54.0433 63.5889 51.7344 66.6274Z" fill="#005F9A"/>
                                        </svg>
                                        <span class="me-2">{{ $t('outlook-calendar') }}</span>
                                    </a>
                                    <a :data-umami-event="occurrence? 'add-to-calendar-occurrence-ics' : 'add-to-calendar-meeting-ics'" :data-umami-event-id="occurrence ?? meeting.id"
                                    style="cursor: pointer;" @click="downloadCalendarFile(meeting.calendar_links.ics_single)">
                                        <svg width="45" height="40" viewBox="0 0 122 109" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M45.5572 11.2841C45.5572 8.36628 48.094 6 51.2338 6C54.3737 6 56.9105 8.36628 56.9105 11.2841V16.5682H79.617V11.2841C79.617 8.36628 82.1537 6 85.2936
                                            6C88.4335 6 90.9702 8.36628 90.9702 11.2841V16.5682H99.4851C104.186 16.5682 108 20.1168 108 24.4943V32.4205H28.5273V24.4943C28.5273 20.1168 32.3396 16.5682
                                            37.0423 16.5682H45.5572V11.2841ZM108 82.6193C108 86.9952 104.186 90.5455 99.4851 90.5455H37.0423C32.3396 90.5455 28.5273 86.9952 28.5273 82.6193V37.7045H108V82.6193Z"
                                            fill="#005F9A"/>
                                            <path d="M17 52V101.036H64.3455" stroke="#005F9A" stroke-width="9" stroke-linecap="round"/>
                                        </svg>
                                        <span class="ms-1">{{ $t('calendar-invite') }}</span>
                                    </a>
                                </div>
                                <!--Mobile & tablet-->
                                <div class="d-lg-none d-xl-none" style="display: flex; justify-content: space-between; font-size: small;">
                                    <a :data-umami-event="occurrence? 'add-to-calendar-occurrence-google' : 'add-to-calendar-meeting-google'" :data-umami-event-id="occurrence ?? meeting.id"
                                    @click="addToCalendar('Google', meeting.calendar_links.google)">
                                        <svg width="40" height="35" viewBox="0 0 122 109" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M85.737 30.2629L63.474 27.7893L36.2634 30.2629L33.7893 55L36.2629 79.737L61 82.8291L85.737 79.737L88.2106 54.3819L85.737 30.2629Z" fill="white"/>
                                            <path d="M46.4119 68.6422C44.5629 67.3929 43.2826 65.5688 42.5837 63.1568L46.8758 61.3882C47.2654 62.8725 47.9455 64.0225 48.9165 64.8389C49.8814 65.6553
                                            51.0564 66.0572 52.4293 66.0572C53.8332 66.0572 55.0392 65.6304 56.0469 64.7769C57.0546 63.9234 57.5622 62.8349 57.5622 61.5179C57.5622 60.17 57.0301
                                            59.0687 55.9665 58.2157C54.9029 57.3626 53.5672 56.9354 51.9715 56.9354H49.4918V52.6871H51.7177C53.0906 52.6871 54.2473 52.3163 55.1873 51.5741C56.1273
                                            50.832 56.5973 49.8177 56.5973 48.5252C56.5973 47.3751 56.1766 46.4596 55.3358 45.7734C54.4949 45.0872 53.4309 44.7408 52.1384 44.7408C50.8769 44.7408
                                            49.8748 45.075 49.1327 45.7489C48.3906 46.4229 47.8524 47.2515 47.5126 48.2287L43.2643 46.4601C43.8269 44.8644 44.86 43.4544 46.3748 42.2362C47.89 41.0179
                                            49.8255 40.4055 52.1755 40.4055C53.9131 40.4055 55.4777 40.7397 56.8633 41.4137C58.2484 42.0876 59.3369 43.0215 60.1223 44.2088C60.9076 45.4021 61.2973
                                            46.7383 61.2973 48.2221C61.2973 49.7374 60.9325 51.0172 60.2026 52.0686C59.4727 53.12 58.576 53.9237 57.5124 54.4867V54.74C58.9162 55.3275 60.0602 56.2243
                                            60.9631 57.4303C61.8598 58.6363 62.311 60.0774 62.311 61.7595C62.311 63.4416 61.8843 64.9442 61.0308 66.2616C60.1773 67.579 58.9961 68.6177 57.4997
                                            69.3721C55.9971 70.1264 54.3088 70.51 52.4349 70.51C50.2645 70.5161 48.2609 69.8914 46.4119 68.6422Z" fill="#005F9A"/>
                                            <path d="M72.7497 47.3442L68.0619 50.7517L65.7058 47.1774L74.1597 41.0796H77.4004V69.8422H72.7497V47.3442Z" fill="#005F9A"/>
                                            <path d="M85.737 102L108 79.737L96.8685 74.7898L85.737 79.737L80.7898 90.8685L85.737 102Z" fill="#005F9A"/>
                                            <path d="M31.3157 90.8685L36.2629 102H85.7365V79.7371H36.2629L31.3157 90.8685Z" fill="#005F9A"/>
                                            <path d="M21.4208 8C17.321 8 14 11.321 14 15.4208V79.7366L25.1315 84.6838L36.263 79.7366V30.263H85.7366L90.6838 19.1315L85.737 8H21.4208Z" fill="#005F9A"/>
                                            <path d="M14 79.7371V94.5792C14 98.6795 17.321 102 21.4208 102H36.263V79.7371H14Z" fill="#005F9A"/>
                                            <path d="M85.7371 30.2629V79.7365H108V30.2629L96.8685 25.3157L85.7371 30.2629Z" fill="#005F9A"/>
                                            <path d="M108 30.263V15.4208C108 11.3205 104.679 8 100.579 8H85.7371V30.263H108Z" fill="#005F9A"/>
                                        </svg><br />
                                        <span class="mt-1">{{ $t('google-calendar') }}</span>
                                    </a>
                                    <a :data-umami-event="occurrence? 'add-to-calendar-occurrence-yahoo' : 'add-to-calendar-meeting-yahoo'" :data-umami-event-id="occurrence ?? meeting.id"
                                    @click="addToCalendar('Yahoo', meeting.calendar_links.yahoo)">
                                        <svg width="40" height="35" viewBox="0 0 122 109" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M56.4463 9.16263C52.8525 9.48287 48.1912 10.5148 44.9176 11.7246C42.2489 12.7031 37.7122 15.0159 35.4171 16.546C28.6031 21.1005 23.3191 27.114 19.7608
                                            34.3194C16.8964 40.1371 15.5621 45.0831 15.0995 51.6303C14.6725 57.5903 15.6333 64.4577 17.7148 70.0975C18.6934 72.7484 21.0062 77.303 22.5363 79.598C27.073
                                            86.3943 33.1042 91.7139 40.3097 95.2543C46.1274 98.1187 51.0734 99.453 57.6027 99.9156C63.5806 100.343 70.448 99.3819 76.0878 97.3003C78.7565 96.3218 83.2933
                                            94.0089 85.5883 92.4789C92.4024 87.9243 97.6863 81.9109 101.245 74.7055C104.109 68.8877 105.443 63.9418 105.906 57.4124C106.333 51.4346 105.372 44.5671 103.291
                                            38.9273C102.312 36.2764 99.9992 31.7219 98.4692 29.4268C94.8931 24.0717 90.0539 19.357 84.5209 15.8343C82.7773 14.7135 78.3117 12.543 76.0878 11.7246C70.1455
                                            9.53624 62.9045 8.59331 56.4463 9.16263ZM54.9874 38.8562V40.2795L51.9629 40.315L48.9206 40.3684L52.4611 45.6168C57.3003 52.7867 58.6168 54.6903 58.7592
                                            54.6903C58.8303 54.6903 61.0009 52.7511 63.5628 50.3671L68.2063 46.0616L65.4665 45.9726L62.7266 45.8837L62.3352 44.7273C62.1217 44.0868 61.9438 43.4285 61.9438
                                            43.2506C61.926 42.9659 62.5487 42.9481 72.4406 42.9481C79.2013 42.9481 82.9196 43.0015 82.8841 43.1261C82.8663 43.215 82.3147 43.8911 81.692 44.6383L80.5534
                                            45.9726H78.2939C76.1946 45.9726 75.9633 46.0082 75.1627 46.4352C73.2412 47.4493 66.3382 52.9646 63.3849 55.829C60.2003 58.9424 60.4315 58.2842 60.5739 63.8172C60.645
                                            66.3614 60.734 68.5141 60.7874 68.6031C60.8407 68.6742 62.7088 68.7454 64.9505 68.7454C67.4769 68.7454 69.0603 68.8166 69.1314 68.9233C69.1848 69.0301 69.1848 69.6705
                                            69.1137 70.3466L68.9891 71.592H57.5494H46.0918V70.1865V68.781L49.9169 68.7098C54.8273 68.6387 54.5071 68.8699 54.6138 65.2583C54.6494 63.835 54.6138 61.7535 54.5427
                                            60.6326C54.4181 58.6578 54.4003 58.551 53.742 57.5725C51.8918 54.8327 43.8857 45.2076 40.8612 42.0942L39.0821
                                            40.2795H35.5594H32.0368V38.8562V37.4329H43.5121H54.9874V38.8562ZM82.6172 49.2818C84.5386 49.4597 86.1221 49.6376 86.1221 49.691C86.1043 49.7444 85.1613 53.2315
                                            84.0049 57.448L81.9055 65.0982L80.251 65.0626C79.3436 65.0448 78.4896 64.9915 78.3651 64.9381C78.1516 64.8669 78.116 63.408 78.116 56.8075V48.7659L78.6142
                                            48.8726C78.881 48.926 80.6957 49.1217 82.6172 49.2818ZM80.0019 67.6957C81.0694 67.8025 81.9589 67.9092 81.9945 67.9448C82.0123 67.9626 81.9055 68.7988 81.7454
                                            69.7951L81.443 71.6098L79.735 71.503C78.7921 71.4319 77.9203 71.3607 77.8136 71.3251C77.4755 71.2184 77.4933 67.5 77.8136 67.5C77.9559 67.5 78.9344 67.589 80.0019
                                            67.6957Z" fill="#005F9A"/>
                                        </svg><br />
                                        <span>{{ $t('yahoo-calendar') }}</span>
                                    </a>
                                    <a :data-umami-event="occurrence? 'add-to-calendar-occurrence-outlook' : 'add-to-calendar-meeting-outlook'" :data-umami-event-id="occurrence ?? meeting.id"
                                    @click="addToCalendar('Outlook', meeting.calendar_links.outlook)">
                                        <svg width="40" height="35" viewBox="0 0 122 109" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M72.3179 28.845V46.6873L78.9089 50.6135C79.0828 50.6614 79.4594 50.6649 79.6332 50.6135L108 32.521C108 30.3798 105.889 28.845 104.697 28.845H72.3179Z"
                                            fill="#005F9A"/>
                                            <path d="M72.3215 53.0105L78.3355 57.104C79.1828 57.721 80.2038 57.104 80.2038 57.104C79.1864 57.721 108 38.7568 108 38.7568V73.0976C108 76.8359 105.585 78.4037
                                            102.87 78.4037H72.3179V53.0105H72.3215Z" fill="#005F9A"/>
                                            <path d="M42.9502 44.6423C40.955 44.6423 39.3653 45.58 38.1914 47.4517C37.0176 49.3235 36.429 51.8016 36.429 54.8859C36.429 58.0161 37.0176 60.4906 38.1914
                                            62.3095C39.3653 64.1319 40.9057 65.0378 42.8092 65.0378C44.7726 65.0378 46.3306 64.1531 47.4798 62.3835C48.6289 60.614 49.207 58.1571 49.207 55.0163C49.207 51.7416
                                            48.65 49.1931 47.5326 47.3707C46.4152 45.5518 44.8889 44.6423 42.9502 44.6423Z" fill="#005F9A"/>
                                            <path d="M15.1733 18.5749V90.3963L69.8105 101.852V8L15.1733 18.5749V18.5749ZM51.7344 66.6274C49.4255 69.6659 46.4152 71.1887 42.6999 71.1887C39.0797 71.1887
                                            36.1328 69.7153 33.8522 66.7719C31.5751 63.825 30.433 59.9899 30.433 55.2594C30.433 50.2645 31.5892 46.2248 33.9051 43.1405C36.221 40.0561 39.2877 38.5122 43.1053
                                            38.5122C46.7113 38.5122 49.63 39.9856 51.8542 42.9396C54.082 45.8935 55.1959 49.7851 55.1959 54.6178C55.1994 59.5845 54.0433 63.5889 51.7344 66.6274Z" fill="#005F9A"/>
                                        </svg><br />
                                        <span>{{ $t('outlook-calendar') }}</span>
                                    </a>
                                    <a :data-umami-event="occurrence? 'add-to-calendar-occurrence-ics' : 'add-to-calendar-meeting-ics'" :data-umami-event-id="occurrence ?? meeting.id"
                                    style="color: #005f9a; cursor: pointer;" @click="downloadCalendarFile(meeting.calendar_links.ics_single)">
                                        <svg width="40" height="35" viewBox="0 0 122 109" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M45.5572 11.2841C45.5572 8.36628 48.094 6 51.2338 6C54.3737 6 56.9105 8.36628 56.9105 11.2841V16.5682H79.617V11.2841C79.617 8.36628 82.1537 6 85.2936
                                            6C88.4335 6 90.9702 8.36628 90.9702 11.2841V16.5682H99.4851C104.186 16.5682 108 20.1168 108 24.4943V32.4205H28.5273V24.4943C28.5273 20.1168 32.3396 16.5682
                                            37.0423 16.5682H45.5572V11.2841ZM108 82.6193C108 86.9952 104.186 90.5455 99.4851 90.5455H37.0423C32.3396 90.5455 28.5273 86.9952 28.5273 82.6193V37.7045H108V82.6193Z"
                                            fill="#005F9A"/>
                                            <path d="M17 52V101.036H64.3455" stroke="#005F9A" stroke-width="9" stroke-linecap="round"/>
                                        </svg><br />
                                        <span class="text-primary">{{ $t('calendar-invite') }}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-11" style="background-color: var(--bs-body-bg); border-radius: 1rem; box-shadow: 6px 3px 3px #00000029;">
                <div v-if="showLoadingModal">
                    <div class="py-5 mt-3 mb-n4 loadingModal" style="text-align: center;">
                        <img class="d-none d-md-none d-lg-inline-block" src="~resonance-theme/src/assets/img/brand/resonance-logo-text.svg" style="max-width: 320px; margin-bottom: 50px;"/>
                        <img class="d-lg-none d-xl-none" src="~resonance-theme/src/assets/img/brand/resonance-logo-text.svg" style="max-width: 65%; margin-bottom: 40px;"/>
                        <h3 class="typing mb-2">{{ $t('meeting.joining-the-zoom-room') }}</h3>
                        <div style="height: 130px;">
                            <lottie-player
                                autoplay
                                loop
	                            speed="2.5"
                                src="/img/animations/custom_loader.json"
                                >
                            </lottie-player>
                        </div>
                    </div>
                </div>
            </div>
            <b-modal id="new-user-modal" v-model="showNewUserModal" hide-header hide-footer no-close-on-esc no-close-on-backdrop>
                <span v-if="timeToMeeting(meeting.start).futureMeeting" class="fs-3 pointer pe-0" style="float: right;" @click="$bvModal.hide('new-user-modal')">
                    <i class="fa-solid fa-xmark"></i>
                </span>
                <div class="pb-2" style="text-align: center;">
                    <lottie-player
                        autoplay
                        loop
                        src="/img/animations/email_received_animation.json"
                        style="width: 200px; margin: auto;"
                        >
                    </lottie-player>
                    <span>{{ $t('your-account-has-been-successfully-created-with-resonance-check-your-email-for-further-details') }}</span>
                </div>
            </b-modal>
        </div>
    </div>
    <div v-if="busy" class="text-center fixed-centered" style="height: 130px;">
        <lottie-player
            autoplay
            loop
	        speed="2.5"
            src="/img/animations/custom_loader.json"
            >
        </lottie-player>
    </div>
</div>
</template>
<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import moment from 'moment';
import orderBy from 'lodash/orderBy';

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      meeting: {},
      network: {},
      occurrence: '',
      form: {
        email: '',
        first_name: '',
        last_name: '',
        job_title: '',
        workplace: '',
        futureMeeting: false,
        name_prefix: '',
        name_suffix: '',
        speciality: '',
        phone_number: '',
        city_workplace: '',
        country_workplace: '',
        updatedUser: false,
        loggedInUser: false,
        newUser: false,
        userCheck: false,
        join_network: true,
        is_hcp: false,
        is_industry: false,
        is_other: false,
      },
      formData: {
        id: '',
        first_name: '',
        last_name: '',
        job_title: '',
        workplace: '',
        futureMeeting: false,
        name_prefix: '',
        name_suffix: '',
        speciality: '',
        phone_number: '',
        city_workplace: '',
        country_workplace: '',
        updatedUser: true,
        loggedInUser: false,
        newUser: false,
        userCheck: false,
        is_hcp: '',
        is_industry: '',
        is_other: '',
      },
      user_id: '',
      showMeetingInfo: true,
      showUserForm: true,
      showNewUserForm: false,
      showLoadingModal: false,
      showNewUserModal: false,
      showShareLinks: false,
      busy: true,
      state: '',
    };
  },
  computed: {
    countries() {
      return this.$store.getters['countries'];
    },
    states() {
      return this.$store.getters['states'];
    },
    selectedRole: {
      get() {
        if (this.form.is_hcp) return 'hcp';
        if (this.form.is_industry) return 'industry';
        if (this.form.is_other) return 'other';
        return '';
      },
      set(value) {
        this.form.is_hcp = value === 'hcp';
        this.form.is_industry = value === 'industry';
        this.form.is_other = value === 'other';
      },
    },
  },
  watch: {
    'form.email'(newEmail) {
      localStorage.setItem('join_meeting_email', newEmail);
    },
  },
  created() {
    this.$store.dispatch('loadCountries');
    this.$store.dispatch('loadStates');
  },
  mounted() {
    let url = 'networks/meetings/' + this.$route.params.id;
    let previousUrl = 'networks/meetings/' + this.$route.params.id;
    let storedJoinEmail = localStorage.getItem('join_meeting_email');
    if (storedJoinEmail) {
        this.form.email = storedJoinEmail;
    }
    if (this.$route.query.user) {
        this.user_id = this.$route.query.user;
    } else if (this.$store.getters['user']) {
        this.user_id = this.$store.getters['user']['user_id'];
    } else {
        this.user_id = null;
    }
    this.$http.get(url).then(resp => {
        this.network = resp.data.network;
        if (resp.data.occurrences != '') {
            let occurrences = {
                upcoming : [],
                previous : [],
            };
            for (let ocurrence of (resp.data.occurrences)) {
                let start = this.utcToLocal(ocurrence.start).format();
                let today = moment(new Date()).format();

                if (start >= today) {
                    occurrences['upcoming'].push(ocurrence);
                } else {
                    occurrences['previous'].push(ocurrence);
                }
            }
            if (occurrences['upcoming'] == '' && occurrences['previous'] != '') {
                // if there are no upcoming meetings but previous meetings, check if there's a live meeting first
                let lastOccurrence = this.sortedArray(occurrences['previous'], 'desc')[0];
                previousUrl += '?occurrence=' + lastOccurrence.occurrence_id;
                this.$http.get(previousUrl).then(response => {
                    let today = moment(new Date()).format('DD/MM/YYYY HH:mm:ss');
                    let meetingDate = this.utcToLocal(response.data.start).format('DD/MM/YYYY HH:mm:ss');
                    let ms = moment(meetingDate,"DD/MM/YYYY HH:mm:ss").diff(moment(today,"DD/MM/YYYY HH:mm:ss"));
                    let d = moment.duration(ms);
                    let months = d._data.months;
                    let days = d._data.days;
                    let hours = d._data.hours;
                    let minutes = d._data.minutes;
                    if (months == 0 && days == 0 && hours == 0 && minutes <= 0 && Math.abs(minutes) <= response.data.duration) {
                        this.meeting = response.data;
                        this.occurrence = lastOccurrence.occurrence_id;
                        this.load();
                    } else {
                        this.meeting = resp.data;
                        this.load();
                    }
                });
            } else if (occurrences['previous'] == '' && occurrences['upcoming'] != '') {
                // if there are no previous meetings, picks the first upcoming meeting (based on date order)
                for (let occurrence of this.sortedArray(occurrences['upcoming'], 'asc')){
                    url += '?occurrence=' + occurrence.occurrence_id;
                    this.$http.get(url).then(response => {
                        this.meeting = response.data;
                        this.occurrence = occurrence.occurrence_id;
                        this.load();
                    });
                    break;
                }
            } else if (occurrences['previous'] != '' && occurrences['upcoming'] != '') {
                // if there are previous and upcoming meetings, checks first if the latest previous meeting is live and if so picks it
                for (let occurrence of this.sortedArray(occurrences['previous'], 'desc')){
                    previousUrl += '?occurrence=' + occurrence.occurrence_id;
                    this.$http.get(previousUrl).then(response => {
                        let today = moment(new Date()).format('DD/MM/YYYY HH:mm:ss');
                        let meetingDate = this.utcToLocal(response.data.start).format('DD/MM/YYYY HH:mm:ss');
                        let ms = moment(meetingDate,"DD/MM/YYYY HH:mm:ss").diff(moment(today,"DD/MM/YYYY HH:mm:ss"));
                        let d = moment.duration(ms);
                        let months = d._data.months;
                        let days = d._data.days;
                        let hours = d._data.hours;
                        let minutes = d._data.minutes;
                        if (months == 0 && days == 0 && hours == 0 && minutes <= 0 && Math.abs(minutes) <= response.data.duration) {
                            this.meeting = response.data;
                            this.occurrence = occurrence.occurrence_id;
                            this.load();
                        } else {
                            // if there are no live meetings, picks the first upcoming meeting (based on date order)
                            for (let occurrence of this.sortedArray(occurrences['upcoming'], 'asc')){
                                url += '?occurrence=' + occurrence.occurrence_id;
                                this.$http.get(url).then(response => {
                                    this.meeting = response.data;
                                    this.occurrence = occurrence.occurrence_id;
                                    this.load();
                                });
                                break;
                            }
                        }
                    });
                    break;
                }
            }
        } else {
            this.meeting = resp.data;
            this.load();
        }
    });
  },
  methods: {
    utcToLocal: function (dt) {
      return moment.utc(dt).local();
    },
    sortedArray(array, order) {
        return orderBy(array, 'start', order);
    },
    timeToMeeting(start) {
        let time = [];
        let today = moment(new Date()).format('DD/MM/YYYY HH:mm:ss');
        let meetingDate = this.utcToLocal(start).format('DD/MM/YYYY HH:mm:ss');
        let ms = moment(meetingDate,"DD/MM/YYYY HH:mm:ss").diff(moment(today,"DD/MM/YYYY HH:mm:ss"));
        let d = moment.duration(ms);
        let months = d._data.months;
        let days = d._data.days;
        let hours = d._data.hours;
        let minutes = d._data.minutes;
        let meetingAboutToStart = false;
        let oldMeeting = false;
        let liveMeeting = false;
        let futureMeeting = false;
        if (months == 0 && days == 0 && hours == 0) {
            if(minutes > 0 && minutes <= 20){
                meetingAboutToStart = true;
            }
            if(minutes <= 0 && Math.abs(minutes) <= this.meeting.duration){
                liveMeeting = true;
            }
        }
        if (months <= 0 && days <= 0 && hours <= 0 && minutes <= 0 && liveMeeting == false) {
            oldMeeting = true;
        }
        if (months >= 0 && days >= 0 && hours >= 0 && minutes > 0 && meetingAboutToStart == false){
            futureMeeting = true;
        }
        time = { 'months': months, 'days': days, 'hours': hours, 'minutes': minutes,
        'meetingAboutToStart': meetingAboutToStart, 'oldMeeting': oldMeeting, 'liveMeeting': liveMeeting, 'futureMeeting': futureMeeting };
        return time;
    },
    frequency() {
        if(this.meeting.recurring_data){
            let recurringData = JSON.parse(this.meeting.recurring_data);
            return recurringData.frequency+' ';
        } else {
            return ' ';
        }
    },
    submitForm() {
        let url = 'join-meeting/' + this.$route.params.id;
        url += this.occurrence != '' ? '/' + this.occurrence + '/' + this.user_id : '/' + null + '/' + this.user_id;
        this.form.userCheck = true;
        if (this.timeToMeeting(this.meeting.start).futureMeeting) {
            this.form.futureMeeting = true;
        }
        this.$http.post(url, this.form).then(resp => {
            if (resp.data.membership_expired) {
                this.membershipExpired();
            } else if (resp.data.error) {
                this.serverError();
            } else {
                this.form.userCheck = false;
                if(resp.data == this.form.email) {
                    // non registered user
                    if (this.timeToMeeting(this.meeting.start).futureMeeting) {
                        this.showShareLinks = true;
                        this.showUserForm = false;
                    } else {
                        this.form.newUser = true;
                        this.showUserForm = false;
                        this.showNewUserForm = true;
                    }
                } else {
                    // user is registered
                    this.user_id = resp.data.user_id;
                    this.formData.first_name = resp.data.first_name;
                    this.formData.last_name = resp.data.last_name;
                    this.formData.job_title = resp.data.job_title;
                    this.formData.workplace = resp.data.workplace;
                    this.formData.name_prefix = resp.data.name_prefix;
                    this.formData.name_suffix = resp.data.name_suffix;
                    this.formData.speciality = resp.data.job_category_other;
                    this.formData.phone_number = resp.data.phone_number;
                    this.formData.city_workplace = resp.data.city;
                    this.formData.country_workplace = resp.data.country;
                    this.formData.is_hcp = resp.data.is_hcp;
                    this.formData.is_industry = resp.data.is_industry;
                    this.formData.is_other = resp.data.is_other;
                    this.showUserForm = false;
                    this.proceedToMeeting();
                    //this.showUpdateForm = true;
                }
            }
        });
    },
    validateInputs(action) {
        if (!this.selectedRole) {
            this.$swal.fire({
                icon: 'error',
                title: 'Validation Error',
                text: 'Please select one of the options: Healthcare practitioner, Industry, or Other.',
            });
            return;
        }
        if (action == 'create') {
            const isEmptyOrWhitespace = [this.form.first_name, this.form.last_name, this.form.job_title, this.form.workplace]
                .some(value => value.trim().replace(/\s/g, '') === '');
            let isInvalid = false;

            if (!isEmptyOrWhitespace) {
                if (!this.form.country_workplace) {
                    isInvalid = true;
                }
                if (this.form.country_workplace.name === 'UNITED STATES') {
                    // check if state is empty for UNITED STATES
                    if (!this.state) {
                        isInvalid = true;
                    }
                } else {
                    // check if city_workplace is empty for other countries
                    if (this.form.city_workplace.trim().replace(/\s/g, '') === '') {
                        isInvalid = true;
                    }
                }
            } else {
                isInvalid = true;
            }

            if (isInvalid) {
                // at least one required field is missing or contains only whitespace
                this.$swal.fire({
                    icon: 'error',
                    title: 'Please fill all the required fields',
                });
            } else {
                this.submitNewUserForm();
            }
        }/* else {
            const isEmptyOrWhitespace = [this.formData.first_name, this.formData.last_name, this.formData.job_title, this.formData.workplace]
            .some(value => value.trim().replace(/\s/g, '') === '');
            if (isEmptyOrWhitespace) {
                this.$swal.fire({
                    icon: 'error',
                    title: 'Please fill all the required fields',
                });
            } else {
                this.updateUserForm(); // now called proceedToMeeting
            }
        }*/
    },
    submitNewUserForm() {
        let url = 'join-meeting/' + this.$route.params.id;
        url += this.occurrence != '' ? '/' + this.occurrence : '/' + null;
        url += '/' + this.user_id;
        if (this.form.country_workplace) {
            if (typeof this.form.country_workplace === 'object' && this.form.country_workplace.name) {
                const exceptions = ['and', 'of', 'the'];
                this.form.country_workplace = this.form.country_workplace.name.toLowerCase()
                .split(' ')
                .map((word, index) => {
                    if (index === 0 || !exceptions.includes(word)) {
                        return word.charAt(0).toUpperCase() + word.slice(1);
                    }
                    return word;
                })
                .join(' ');
            }
        }
        if (this.state) {
            this.form.city_workplace = this.state;
        }
        if (this.form.city_workplace) {
            if (typeof this.form.city_workplace === 'object' || this.form.country_workplace === 'UNITED STATES') {
                this.form.city_workplace = this.form.city_workplace.name;
            }
        }
        if (this.timeToMeeting(this.meeting.start).futureMeeting) {
            this.form.futureMeeting = true;
            this.$http.post(url, this.form).then(resp => {
                if (resp.data.membership_expired) {
                    this.membershipExpired();
                } else if (resp.data.error) {
                    this.serverError();
                } else {
                    this.showNewUserForm = false;
                    this.showShareLinks = true;
                    this.showNewUserModal = true;
                }
            });
        } else if (this.timeToMeeting(this.meeting.start).oldMeeting) {
            window.location.reload();
        } else {
            this.$http.post(url, this.form).then(resp => {
                if (resp.data.membership_expired) {
                    this.membershipExpired();
                } else if (resp.data.error) {
                    this.serverError();
                } else {
                    this.showMeetingInfo = false;
                    this.showNewUserModal = true;
                    setTimeout(() => {
                        this.showNewUserModal = false;
                    }, 3000);
                    setTimeout(() => {
                        this.showLoadingModal = true;
                    }, 4000);
                    setTimeout(() => {
                        window.location.href = this.meeting.zoom_meeting.url;
                    }, 7000);
                }
            });
        }
    },
    proceedToMeeting(){
        let url = 'join-meeting/' + this.$route.params.id;
        url += this.occurrence != '' ? '/' + this.occurrence + '/' + this.user_id : '/' + null + '/' + this.user_id;
        if (this.timeToMeeting(this.meeting.start).futureMeeting) {
            this.formData.futureMeeting = true;
            this.$http.post(url, this.formData);
            //this.showUpdateForm = false;
            this.showShareLinks = true;
        } else if (this.timeToMeeting(this.meeting.start).oldMeeting) {
            window.location.reload();
        } else {
            this.showMeetingInfo = false;
            this.showLoadingModal = true;
            setTimeout(() => {
                this.$http.post(url, this.formData).then(resp => {
                    if (resp.data.membership_expired) {
                        this.membershipExpired();
                    } else if (resp.data.error) {
                        this.serverError();
                    } else {
                        window.location.href = this.meeting.zoom_meeting.url;
                    }
                });
            }, 5000)
        }
    },
    load() {
        this.busy = false;
        if(this.user_id != null) {
            if(this.timeToMeeting(this.meeting.start).meetingAboutToStart || this.timeToMeeting(this.meeting.start).liveMeeting){
                this.showMeetingInfo = false;
                this.form.loggedInUser = true;
                this.form.userCheck = false;
                let url = 'join-meeting/' + this.$route.params.id;
                url += this.occurrence != '' ? '/' + this.occurrence : '/' + null;
                url += '/' + this.user_id;
                // waits for 5 seconds before redirecting to meeting
                this.showLoadingModal = true;
                setTimeout(() => {
                    this.$http.post(url, this.form).then(resp => {
                        if (resp.data.membership_expired) {
                            this.membershipExpired();
                        } else if (resp.data.error) {
                            this.serverError();
                        } else {
                            window.location.href = this.meeting.zoom_meeting.url;
                        }
                    });
                }, 5000);
            }
            if (this.timeToMeeting(this.meeting.start).futureMeeting) {
                this.showUserForm = false;
                this.showShareLinks = true;
            }
        }
    },
    addToCalendar(calendar_name, calendar_link) {
        if (window.umami && typeof window.umami.track === 'function') {
            if (this.occurrence) {
            window.umami.track(`add-to-calendar-${calendar_name.toLowerCase()}-occurrence-${this.occurrence}`);
            } else {
            window.umami.track(`add-to-calendar-${calendar_name.toLowerCase()}-meeting-${this.meeting.id}`);
            }
        }
        let url = 'meetings/calendar/' + this.$route.params.id;
        const userId = this.user_id !== null ? this.user_id : 'null';
        const occurrenceId = this.occurrence !== '' ? this.occurrence : 'null';
        url += `/${occurrenceId}/${userId}/${calendar_name}`;

        this.$http.post(url).then(() => {
            window.location.href = calendar_link;
        });
    },
    downloadCalendarFile(data, name = this.meeting.title + '.ics') {
        if (window.umami && typeof window.umami.track === 'function') {
            if (this.occurrence) {
                window.umami.track(`add-to-calendar-ics-occurrence-${this.occurrence}`);
            } else {
                window.umami.track(`add-to-calendar-ics-meeting-${this.meeting.id}`);
            }
        }
        var link = document.createElement('a');
        link.download = name;
        link.href = data;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        const userId = this.user_id !== null ? this.user_id : 'null';
        const occurrenceId = this.occurrence !== '' ? this.occurrence : 'null';
        let url = `meetings/calendar/${this.$route.params.id}/${occurrenceId}/${userId}/ICS`;
        this.$http.post(url);
    },
    serverError() {
        this.$swal.fire({
            title: 'There was a problem processing your request.',
            icon: 'error',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: 'Try again',
            cancelButtonText: 'Join meeting anyway',
            confirmButtonColor: '#198754',
            cancelButtonColor: '#005f9a',
        }).then((result) => {
            if (result.isConfirmed) {
                window.location.reload();
            } else {
                window.location.href = this.meeting.zoom_meeting.url;
            }
        })
    },
    membershipExpired() {
        this.$swal.fire({
            title: 'Your membership has expired.',
            text: 'Please renew your membership to continue.',
            icon: 'error',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: 'Contact us',
            cancelButtonText: 'Cancel',
            confirmButtonColor: '#198754',
            cancelButtonColor: '#005f9a',
        }).then((result) => {
            if (result.isConfirmed) {
                window.location.href = 'mailto:support@resonancehealth.org?subject=Membership Renewal&body=Please help me renew my membership.';
            } else {
                window.location.href = '/networks/' + this.network.slug;
            }
        });
    },
  },
};
</script>
<style>
.py-3 .row .card {
  float: left;
  padding: 0;
  box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.15);
}
.card .data {
  float: right;
  width: 75%;
  height: 100%;
}
.card .data .content {
  padding: 10px 12px 10px 10px;
  position: relative;
  z-index: 1;
  height: 100%;
  color: #5C6D80;
}
.card .data .content .title {
  font-weight: 400;
}
.card .data .content span {
    position: absolute;
    font-size: 14px;
    font-weight: 700;
}
.card .data .content h6 {
    position: absolute;
    font-size: 14px;
}
.image {
  float: left;
  width: 25%;
  position: relative;
}
.image span {
    position: absolute;
    font-size: 13px;
    font-weight: 600;
	bottom: 0;
	left: 0;
	background: #005F9A;
    opacity: 0.7;
	color:#fff;
	width: 100%;
	margin: 0;
    text-align: center;
    border-bottom-left-radius: 10px;
}
.card-image {
  display: block;
  height: 150px;
  margin-top: auto;
  margin-bottom: auto;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.typed-cursor.typed-cursor, .typed-cursor.typed-cursor--blink {
    display: none;
}
.typing {
  overflow: hidden; /* Ensures the content is not revealed until the animation */
  /*border-right: .15em solid orange;  The typwriter cursor */
  white-space: nowrap; /* Keeps the content on a single line */
  margin: 0 auto; /* Gives that scrolling effect as the typing happens */
  letter-spacing: .02em; /* Adjust as needed */
  animation: 
    typing 4s steps(45, end),
    blink-caret .50s step-end infinite;
}
/* The typing effect */
@keyframes typing {
  from { width: 0 }
  to { width: 100% }
}
/* The typewriter cursor effect
@keyframes blink-caret {
  from, to { border-color: transparent }
  50% { border-color: orange; }
} */
.ignore-css {
  all:unset;
}
.beamer_defaultBeamerSelector {
  display: none;
}
.icons a:hover{
  text-decoration: none;
}
.separator {
  display: flex;
  align-items: center;
  text-align: center;
}
.separator::before,
.separator::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #5C6D80;
}
.separator:not(:empty)::before {
  margin-right: .25em;
}
.separator:not(:empty)::after {
  margin-left: .25em;
}
</style>